import React from 'react';
import * as AspectRatio from '@radix-ui/react-aspect-ratio';
import { RaportSummaryCard } from '../RaportSummaryCard/RaportSummaryCard';
import type { ReportSummaryCardProps } from './RaportHeader.types';
import clsx from 'clsx';
import { AuthorizedImage } from '@/components/AuthorizedImage';

export const ReportSummaryCard: React.FC<ReportSummaryCardProps> = ({
  vehicleBrand,
  vehicleModel,
  logoUrl,
  vinNumber,
  orderNumber,
  packageType,
  reportDate,
  pagesCount,
  carImageUrl,
  mainPhoto,
  vehicleType = 'Sedan',
  photoCount = 0,
  onDownloadPdf,
  pdfLoading,
  onDownloadImages,
  i18n,
}) => {
  // i18n fallbacks
  const photoGalleryLabel = i18n?.photoGalleryLabel || 'Galeria zdjęć';
  const noVehiclePhotoMessage =
    i18n?.noVehiclePhotoMessage || 'Brak zdjęcia pojazdu';
  const resolvedCarImageUrl = mainPhoto
    ? mainPhoto.fullSizeState === 'placeholder'
      ? mainPhoto.src
      : mainPhoto.fullSrc || mainPhoto.src
    : carImageUrl;
  const hasCarImage = Boolean(mainPhoto || carImageUrl);

  React.useEffect(() => {
    mainPhoto?.requestThumbnail?.();
    mainPhoto?.requestFullSize?.();
  }, [mainPhoto]);

  return (
    <div className="flex max-w-[1268px] flex-col-reverse items-center justify-start md:flex-row">
      {hasCarImage && (
        <div className="stack stack-top relative w-full rounded-lg md:h-[250px] md:w-[35vw] xl:w-[400px]">
          <div
            className="flex flex-col items-start rounded-[25px] bg-white p-5"
            style={{ filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))' }}
          >
            <p className="mb-5 text-xl font-semibold text-left text-text-primary">
              {photoGalleryLabel} <span className="text-gray-500">({photoCount})</span>
            </p>
            <div className="absolute z-5 text-blue md:left-0 md:right-0 right-[20px] top-[20px] md:top-[-12px] text-center"><a href="#gallery" className="text-xs">(Zobacz galerię)</a></div>
            <AspectRatio.Root ratio={16 / 9}>
              <div className="relative h-full w-full overflow-hidden rounded-[25px]">

                {resolvedCarImageUrl ? (
                  <AuthorizedImage
                    src={resolvedCarImageUrl}
                    alt={`${vehicleBrand} ${vehicleModel}`}
                    className="object-cover w-full h-full"
                    skeletonClassName="w-full h-full animate-pulse bg-gray-200"
                    onError={() => mainPhoto?.refreshVariant?.('LARGE')}
                  />
                ) : (
                  mainPhoto ? (
                    <AuthorizedImage
                      src=""
                      alt={`${vehicleBrand} ${vehicleModel}`}
                      className="object-cover w-full h-full"
                      skeletonClassName="w-full h-full animate-pulse bg-gray-200"
                    />
                  ) : (
                    <div className="flex justify-center items-center w-full h-full text-gray-500 bg-gray-200">
                      {noVehiclePhotoMessage}
                    </div>
                  )
                )}
              </div>
            </AspectRatio.Root>
          </div>
          <div
            className="relative rounded-[25px] bg-white shadow-card"
            style={{ filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))' }}
          >

          </div>
          <div
            className="rounded-[25px] bg-[#FFFFFF] shadow-card"
            style={{ filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,0.25))' }}
          ></div>
          {/* <div className="absolute bottom-3 left-3">
            <div className="flex gap-2 items-center px-4 py-2 text-white bg-blue-600 rounded">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
                  fill="white"
                />
                <path
                  d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
                  fill="white"
                />
                <path
                  d="M5 9l2 -4h8l2 4"
                  stroke="white"
                  strokeWidth="2"
                />
                <path
                  d="M5 9h12v5h-3a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2h-3v-5z"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
              <span>{vehicleType}</span>
            </div>
          </div> */}
        </div>
      )}


      <div className={clsx(
        'flex-1 w-1/2 z-[1]',
        hasCarImage ? 'w-full md:-ml-[20px] lg:w-1/2' : 'w-full lg:w-full',
      )}>
        <RaportSummaryCard
          raportType="RA"
          orderNumber={orderNumber}
          packageVariant={packageType}
          reportDate={reportDate}
          vin={vinNumber}
          logoUrl={logoUrl}
          vehicleBrand={vehicleBrand}
          vehicleModel={vehicleModel}
          pageCount={pagesCount}
          downloadPdf={true}
          onDownloadPdf={onDownloadPdf ?? (() => { })}
          pdfLoading={pdfLoading}
          onDownloadPhotos={onDownloadImages}
          showDownloadPhotos={Boolean(onDownloadImages) && photoCount > 0}
        />
      </div>
    </div>
  );
};

export default ReportSummaryCard;
